import React from "react";
import "./footer.css";
import { socialMediaLinks, usefulLinks } from "./footerData";
import HippoServices from "./HippoServices";

function Footer() {
  const currentYear = new Date().getFullYear();
  const startYear = 2019;
  return (
    <footer className="container footer-container" role="contentinfo">
      <div className="horizontal-line" />
      <section className="footer-top">
        <section aria-labelledby="useful-links">
          <h6 id="useful-links">Useful Links</h6>
          <ul className="useful-links-list">
            {usefulLinks.map((link, i) => (
              <li className="link-section" key={i}>
                <a
                  href={link.path}
                  target={link.newTab ? "_blank" : "_self"}
                  rel={link.newTab ? "noopener noreferrer" : ""}
                  aria-label={
                    link.newTab
                      ? `Open ${link.title} in a new tab`
                      : `Go to ${link.title}`
                  }
                >
                  {link.title}
                </a>
              </li>
            ))}
            <li className="link-section">
              <a
                id="termly-consent-preferences"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  window.displayPreferenceModal();
                  return false;
                }}
              >
                Consent preferences
              </a>
            </li>

            {/* <li className="link-section">
              <a
                href="#"
                onclick="window.displayPreferenceModal();return false;"
                id="termly-consent-preferences"
              >
                Consent Preferences
              </a>
            </li> */}
          </ul>
        </section>
        <section
          aria-labelledby="social-media-links"
          className="social-media-section"
        >
          <h6 id="social-media-links" className="screen-reader-only">
            Social Media Links
          </h6>
          <ul className="social-media-list">
            {socialMediaLinks.map((link, i) => {
              const Icon = link.svg;
              return (
                <li key={i}>
                  <a
                    href={link.path}
                    target={link.newTab ? "_blank" : "_self"}
                    rel={link.newTab ? "noopener noreferrer" : ""}
                    aria-label={
                      link.newTab
                        ? `Open ${link.title} in a new tab`
                        : `Go to ${link.title}`
                    }
                  >
                    <Icon className="text-icon" />
                    <span className="screen-reader-only">{link.title}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </section>
      </section>
      <div className="horizontal-line" />

      <section>
        <p className="footer-copy-right">
          All material herein © {startYear} - {currentYear} Hotels Hippo.com
          (Pvt) Ltd. All rights reserved.
        </p>
        <blockquote className="footer-quote">
          “Explore, relax, and create unforgettable memories with
          HotelsHippo.com, your one-stop gateway to smooth, exciting, and
          personalized travel adventures across the world’s hidden gem.”
        </blockquote>
        <p className="footer-final-quote">Sri Lanka, a place like no other!</p>
      </section>
      <HippoServices />
    </footer>
  );
}

export default Footer;
